import React from "react";

interface FormHeaderProps {
  title?: string;
  subtitle?: string;
  stepTitle?: string;
  characterImage?: string;
  characterAlt?: string;
  className?: string;
}

export function FormHeader({
  title,
  subtitle,
  stepTitle,
  characterImage,
  characterAlt = "Personagem",
  className = "",
}: FormHeaderProps) {
  return (
    <div className={`flex items-start justify-between mb-8 relative ${className}`}>
      <div className="max-w-lg">
        {title && (
          <h2 className="text-2xl md:text-3xl lg:text-4xl text-green-bb-2 font-bold mb-8">
            {subtitle ? (
              <>
                {title} <br />{" "}
                <span className="text-blue-bb-1">{subtitle}</span>
              </>
            ) : (
              title
            )}
          </h2>
        )}

        {stepTitle && (
          <h2 className="text-3xl md:text-xl font-bold text-gray-bb-1 mb-6">
            {stepTitle}
          </h2>
        )}
      </div>
      {characterImage && (
        <img
          src={characterImage}
          alt={characterAlt}
          className="hidden lg:block absolute right-0 top-0 h-auto z-10"
          style={{ transform: "translateY(20px)" }}
        />
      )}
    </div>
  );
}